var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-expand-transition',[(_vm.showAlways || _vm.pages > 1)?_c('v-row',[_c('v-col',{staticClass:"text-center"},[_c('v-pagination',{attrs:{"value":_vm.value,"length":_vm.pages,"total-visible":7,"circle":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }